module.exports = __webpack_public_path__ + "static/media/x.734cf656.svg";